import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import global_axios  from '../../funciones_globales/interaccionapi';
import {  cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { formatearFecha } from '../../funciones_globales/format';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { formatearLabel } from '../../funciones_globales/format';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormImpor06 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Estados formulario
            operacion: 'M', //G & M
            permiso: 'G',
            ult_transaccion: null,
            num_diario: null,
            dai_num:'',
            esconsolidado:null,
            numconsolidado:null,

            //FECHAS
            fechaProceso: null,
            fechaCompra: null,

            //Input
            compra: '',
            importacion_sel: null,
            transitoLoaded: null,
            ident_prov: null,

            mails: null,
            error: 0
        };
       

        //Properties
        this.actualizarCampos = this.actualizarCampos.bind(this);
        this.getImportacionById = this.getImportacionById.bind(this);

        //ACTIONS
        this.aceptarCompra = this.aceptarCompra.bind(this);
        this.reversarCompra = this.reversarCompra.bind(this);
        this.limpiarPantalla = this.limpiarPantalla.bind(this);
        this.getconsolidado= this.getconsolidado.bind(this);
    }   
    
    //Change over controls
    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [name]: value
        });
    }

    //FUNCTION AGREGADA PROVEEDOR
    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?compra=1&cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }

    getImportacionById(){

        if(this.state.importacion_sel===null){
            alert("Digite un movimiento");
        }else{

            this.getconsolidado()

            global_axios({
                method: 'GET',
                url: '/compras?importacion='+this.state.importacion_sel.value.toString()+'&status=P&status=E'
            })
            .then((response)=> {
                
                if(response.data.length>0){
                    var respuesta = response.data[0];

                    if(respuesta.proDet!==null){
                        let items = {};

                        items.label = respuesta.proDet.RazonSocial+' ('+respuesta.proDet.Proveedor.toString().trim()+')';
                        items.value = respuesta.Proveedor;
                        this.setState({ident_prov: items});
                    }
                    
                    this.setState({compra: respuesta.Compra});

                    if(respuesta.Fecha!==null){
                        var fechaProcess = formatearFecha(respuesta.Fecha.toString().substring(0,10))
                        
                        this.setState({fechaCompra: moment(fechaProcess,'DD/MM/YYYY')})
                    }

                    if(respuesta.EnTransito!==null){
                        this.setState({transitoLoaded: respuesta.EnTransito})
                    }else{
                        this.setState({transitoLoaded: 'S'})
                    }

                    this.setState({operacion: 'M'}); //M => Modificacion
                }
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });
        }
    }

    //Operaciones
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{

                reject('Compra no existe o esta anulada...');
            });
        });
    }

    //CICLO REACT

    componentDidMount(){
        Promise.all([
            this.cargarObjetos('/catalogos?tipo=otros&opcion=IMP-LCOMP'),
            this.props.generar_LogAuditoriaIngresoForm('0306')
         ])
        .then(([res_mail]) => {
            let fechaProceso = getFechaProcesoPorModulo('03');

            if(res_mail===null){
                alert("No es posible cargar los destinatarios, no se puede continuar")
            }else{
                this.setState({mails: formatearLabel(res_mail[0].Descripcion), error:1})
            }
            this.setState({fechaProceso: moment(fechaProceso, "DD/MM/YYYY"), permiso: this.props.permiso})
        });        
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0306');
    }
    
    //FUNCION BOTONES
    aceptarCompra(){
        var errors = "";
        var proceder = true;
        var data = {};
      

        let fechaProceso = getFechaProcesoPorModulo('03');

        if(this.state.mails===null){
            proceder = true;
            errors = errors+"- No se cargaron los destinatarios, imposible continuar\n";
        }
        
        if(this.state.dai_num===""){
            proceder = false;
            errors = errors+"- Debe Ingresa un DAI para continuar.\n";
        }
        
        // Validacion de fecha de proceso que se puede cambiar ------------------------------
        if (this.props.permiteCambioFProceso==='S'){
            let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProceso, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            if(resultadoValidFProceso.esValida===false){
                proceder = false;
                errors = errors + resultadoValidFProceso.msg+'\n'
            }
        }

        if(this.state.importacion_sel===null){
            proceder = false;
            errors=errors+"- Digite un movimiento.\n";
        }
        

        if (this.state.esconsolidado==='S'  && this.state.numconsolidado!=='' ) 
            {
                if (this.state.numconsolidado !==this.state.dai_num )
                {
                    errors=errors+"- Importacion esta consolidada y tiene otro numero de DAI.\n";
                    proceder = false;
                }
            }

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }


        if(proceder === true ){
            var mensaje;
            mensaje = window.confirm("¿Esta seguro que quiere liberar la importación #"+this.state.importacion_sel.value+"?"); 
            
            if (mensaje){
                data.Localidad = '01';
                data.mails = this.state.mails;
                data.tema = "Liberación de importación #:"+this.state.importacion_sel.value
                data.msn = "La compra #: "+this.state.compra+" correspondiente a la importación #:"
                +this.state.importacion_sel.value+" con el proveedor "+this.state.ident_prov.label+" ha sido liberada.\n\n Mensaje automático generado por el módulo Itera."
                data.Usuario= this.props.usuario;
                data.IdRegAudit = this.props.IdRegAudit;
                data.Fecha = formatearFechaMoment_a_String(this.state.fechaProceso);
                data.Observacion = "LCOMP; IMP:"+this.state.importacion_sel.value+" COMP:"+this.state.compra+" MOD";
                data.dai_num= this.state.dai_num
                data.importacion= this.state.importacion_sel.value

                let config_request = {
                    method: 'PATCH',
                    url: '/compras/'+this.state.compra+'/liberarcompra/',
                    data
                }
                
                global_axios(config_request)
                .then((response)=> {             
                    alert(response.data.msg);
                    //console.log("SEC: ", response.data)
                    this.setState({ult_transaccion: response.data.transaction, num_diario: response.data.diario})
                    this.limpiarPantalla();
                    this.setState({operacion: 'G'});
                })
                .catch((error)=>{                  
                    alert(error.response?error.response.data.msg:error.message);                
                });
            }

        }else{
            alert(errors);
        }





        
    }

getconsolidado(){

        let config_request = {
            method: 'GET',
            url: '/compras/'+this.state.importacion_sel.value+'/importacionConsolidado/',
        }
        global_axios(config_request)
        .then((response)=> {             
            var respuesta = response.data[0];

            this.setState({esconsolidado: respuesta.Consolidado});
            this.setState({numconsolidado: respuesta.DuiConsolidado});
        
        })
        .catch((error)=>{                  
            alert(error.response?error.response.data.msg:error.message);                
        });
}

    reversarCompra(){
        var errors = "";
        var proceder = true;
        var data = {};

        let fechaProceso = getFechaProcesoPorModulo('03');

        if(this.state.mails===null){
            proceder = true;
            errors = errors+"- No se cargaron los destinatarios, imposible continuar\n";
        }

        // Validacion de fecha de proceso que se puede cambiar ------------------------------
        if (this.props.permiteCambioFProceso==='S'){
            let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProceso, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            if(resultadoValidFProceso.esValida===false){
                proceder = false;
                errors = errors + resultadoValidFProceso.msg+'\n'
            }
        }

        if(this.state.importacion_sel===null){
            proceder = false;
            errors=errors+"- Digite un movimiento.\n";
        }

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        if(proceder === true ){
            var mensaje;
            mensaje = window.confirm("¿Esta seguro marcar la importación #"+this.state.importacion_sel.value+" en transito?"); 
            
            if (mensaje){

                data.Localidad = '01';
                data.mails = this.state.mails;
                data.tema = "Liberación de importación #:"+this.state.importacion_sel.value+" REV"
                data.msn = "La compra #: "+this.state.compra+" correspondiente a la importación #:"
                +this.state.importacion_sel.value+" con el proveedor "+this.state.ident_prov.label+" ha sido reversada.\n\n Mensaje automático generado por el módulo Itera."
                data.Usuario= this.props.usuario;
                data.IdRegAudit = this.props.IdRegAudit;
                data.Fecha = formatearFechaMoment_a_String(this.state.fechaProceso);
                data.Observacion = "LCOMP; IMP:"+this.state.importacion_sel.value+" COMP:"+this.state.compra+" REV";

                let config_request = {
                    method: 'PATCH',
                    url: '/compras/'+this.state.compra+'/reversarliberarcompra/',
                    data
                }
                
                global_axios(config_request)
                .then((response)=> {             
                    alert(response.data.msg);
                    //console.log("SEC: ", response.data)
                    this.setState({ult_transaccion: response.data.transaction, num_diario: response.data.diario})
                    this.limpiarPantalla();
                    this.setState({operacion: 'G'});
                })
                .catch((error)=>{                  
                    alert(error.response?error.response.data.msg:error.message);                
                });
            }
        }else{
            alert(errors);
        }
    }

    clear(){
        this.setState({compra:'', ident_prov: null, fechaCompra: null, transitoLoaded: null , dai_num:'', esconsolidado:null, numconsolidado:null, error: 0})
    }

    limpiarPantalla(param){
        this.clear();
        //this.setState({detCajaChica: [], caja_sel: null, tipoDoc_sel: null,observacion: '', operacion: 'G'});
        
        if(param==='A'){
            this.setState({importacion_sel: null });
            }
    }

    render(){
        return(
            <ContenedorForm porc_ancho={80}>
             <HeaderForm>
                <TituloForm>Liberación de importación</TituloForm>
                <LabelCabecera>Ult. trans.: {this.state.ult_transaccion}</LabelCabecera>
                {/* <LabelCabecera>N°. diario: {this.state.num_diario}</LabelCabecera> */}
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit>
                        <Row>
                            {/* <ContainerCol className='col-sm-2' >
                                <LabelForm>Importación:</LabelForm>
                                <InputSearch tipoInput='text' nombre='movimientoId' placeholder='Movimiento' valor={this.state.movimientoId} func_CambiarValor={this.actualizarCampos} 
                                func_BuscarValor={this.getImportacionById} func_OnFocus={()=>{this.limpiarPantalla('B')}} maxLength='10'/> 
                            </ContainerCol> */}
                            <ContainerCol className='col-md-4'>        
                                <LabelForm>Importación:</LabelForm>            
                                <div className='input-group'>
                                <ReactSelectAsync value={this.state.importacion_sel} func_loadOptions={this.getOptions_Importaciones} func_onChange={(value)=>{this.setState({importacion_sel: value!==null?value:null})}}/>
                                    <span className='input-group-addon addon-busq-especif'><button type="button" className='btn btn-default medida-button-busq-especif' onClick={this.getImportacionById}><i className="fa fa-pencil-square-o"></i> Buscar</button></span>
                                </div>
                            </ContainerCol>               
                            <ContainerCol className='col-sm-2 col-sm-offset-6'>
                                <LabelForm>Fecha:</LabelForm>
                                <PickerFecha fechaSeleccionada={this.state.fechaProceso} disabled={!(this.props.permiteCambioFProceso==='S')} 
                                func_onChange={(fechaEscogida)=>{this.setState({fechaProceso: fechaEscogida})}}
                                />
                            </ContainerCol>
                        </Row>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Proveedor:</LabelForm>
                            <ReactSelectAsync value={this.state.ident_prov} disabled={true} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{this.setState({ident_prov: value!==null?value:null})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Compra</LabelForm>
                            <InputText name="compra" mayusculas={true} disabled={true} value={this.state.compra} onChange={this.actualizarCampos} maxLength='100'/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Fecha Compra:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaCompra} disabled={true} 
                            func_onChange={(fechaEscogida)=>{this.setState({fechaCompra: fechaEscogida})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>D.A.I N°:</LabelForm>
                            <InputText name="dai_num" mayusculas={true} value={this.state.dai_num} onChange={this.actualizarCampos} maxLength='100'/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <br/>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm' disabled={this.state.transitoLoaded==='S'?false:true} onClick={this.aceptarCompra}><i className='fa fa-floppy-o fa-lg'/> Aceptar</button>
                                <button type='button' className='btn btn-sm' onClick={()=>{this.limpiarPantalla('A')}}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                                <button type='button' className='btn btn-danger btn-sm' disabled={this.state.transitoLoaded==='N'?false:true} onClick={this.reversarCompra}><i className='fa fa-window-close  fa-lg'/> Reversar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}


const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,}
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormImpor06);